import styled from "styled-components"

export const PageRoot = styled.div<{ $embedded?: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ $embedded }) => ($embedded ? 0 : "20px")};
  padding: ${({ $embedded }) => ($embedded ? "0 0 16px" : "0 20px 16px")};
  ${({ $embedded }) => !$embedded && "max-height: calc(var(--vh, 1vh) * 90 - 205px);"}
  min-height: 0;
`

export const ScrollSection = styled.div<{ $embedded?: boolean }>`
  flex: 1;
  min-height: 0;
  ${({ $embedded }) =>
    !$embedded &&
    `
    overflow-y: auto;
    overflow-x: hidden;
  `}
`

export const SpinnerWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
`

export const Title = styled.h4`
  margin-bottom: 24px;
  line-height: 32px;
  font-size: 24px;
  color: #0f172a;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 12px 18px;
  overflow: hidden;
  background: #f8fafc;
  scroll-margin-top: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const RowHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 12px;
`

export const CheckboxSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;
`

export const AccordionTrigger = styled.button<{ $disabled?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  min-height: 24px;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  text-align: left;
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
`

export const RowLabel = styled.span`
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: #0f172a;
`

export const ChevronWrap = styled.span<{ $open: boolean; $placeholder?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  color: #64748b;
  transition: transform 0.3s ease;
  visibility: ${({ $placeholder }) => ($placeholder ? "hidden" : "visible")};

  svg {
    width: 20px;
    height: 20px;
  }

  transform: rotate(${({ $open }) => ($open ? "180deg" : "0deg")});
`

export const AccordionBody = styled.div<{ $open: boolean }>`
  display: grid;
  grid-template-rows: ${({ $open }) => ($open ? "1fr" : "0fr")};
  transition: grid-template-rows 0.35s ease;
`

export const AccordionInner = styled.div`
  overflow: hidden;
  min-height: 0;
`

export const RowContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 8px 10px;
`

export const CheckboxContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  margin-top: 8px;
`

export const CheckboxLabel = styled.span`
  font-size: 11px;
  font-weight: 400;
  color: #0f172a;
`

export const Footer = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  padding-top: 16px;
  background: #fff;
`

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`
